import { useMutation, useQuery } from "react-query";
import { useFetchContext } from "../../../common/FetchContext";
import { STRESSOR_CHECK_IN_MODE, STRESSOR_CHECK_RESUME_MODE } from "./constants";
import { urls } from "../../../common/urls";

export const useStressTypes = () => {
  const { authAxios } = useFetchContext();

  const getStressTypes = async (): Promise<any> => {
    const { data } = await authAxios.get("/assets/stressors/");
    return data;
  };
  return useQuery("stressTypes", getStressTypes);
};

export const useStressProcedures = (id: string, mode: number | null) => {
  const { authAxios } = useFetchContext();

  const getStressProcedures = async (): Promise<any> => {
    const { data } = await authAxios.get(`/assets/${id}/procedures`);
    return data;
  };
  return useQuery(["stressTypes", id, mode], getStressProcedures, {
    enabled: id !== undefined && id !== null && mode === STRESSOR_CHECK_IN_MODE,
  });
};
//useLinkAssetById
export const useLinkAssetById = (id: string, mode: number | null) => {
  const { authAxios } = useFetchContext();
  const getSubAssets = async (): Promise<any> => {
    const { data } = await authAxios.get(`/asset_subasset/?asset_id=${id}`);
    return data.results;
  };
  return useQuery(["subAsset", id, mode], getSubAssets, {
    enabled: id !== undefined && id !== null && mode === STRESSOR_CHECK_IN_MODE || mode === STRESSOR_CHECK_RESUME_MODE,
  });
};

//getCalibartionData

export const useGetCalibartionData = (assetId: string) => {
  const { authAxios } = useFetchContext();

  const getCalibartionData = async (): Promise<any> => {
    const { data } = await authAxios.get(urls.assets.calibration_data(assetId));
    return data;
  };

  return useQuery(
    ["calibrationData", assetId],
    getCalibartionData,
    { enabled: !!assetId } // only runs if assetId exists
  );
};

//checkLinkedAssets
export const useLinkedAssets = () => {
  const getLinkedAssets = async (params: any): Promise<any> => {
    const { authAxios, id } = params;
    const { data } = await authAxios.get(urls.assets.checkLinkedAssets(id)
    );
    return data;
  };
  return useMutation(getLinkedAssets);
};

//Main Asset List
export const useAvailableMainAssets = (id: boolean) => {
  const { authAxios } = useFetchContext();
  const getAvailablessets = async (): Promise<any> => {
    const { data } = await authAxios.get(urls.assets.listAssets(id));
    return data;
  };
  return useQuery(["subAsset", id], getAvailablessets, {

  });
};

//Link New Assets
export const linkNewAsset = async (params: any): Promise<any> => {
  const { authAxios, payload } = params;
  const { data } = await authAxios.post(urls.assets.linkNewAsset, payload);
  return data;
};

export const useLinkNewAssetSubmit = () => {
  return useMutation(linkNewAsset);
};

export const usePowerSupplySubAsset = () => {
  const { authAxios } = useFetchContext();

  const getPowerSupplySubAsset = async (): Promise<any> => {
    const { data } = await authAxios.get(urls.assets.linkPowerSupplySubAssetGet);
    return data;
  };

  return useQuery("PowerSupplySubAsset", getPowerSupplySubAsset);
};

export const addPowerSupplySubAsset = async (params: any): Promise<any> => {

  const { authAxios, ...postParams } = params;

  const { data } = await authAxios.post(urls.assets.linkPowerSupplySubAssetGet, {
    ...postParams,
  });
  return data;
};


export const usePowerSupplySubAssetInsert = () => {
  return useMutation(addPowerSupplySubAsset);
};

export const useSubAssetLinkedView = () => {
  const { authAxios } = useFetchContext();

  const getsubAssetLinkedView = async (): Promise<any> => {
    const { data } = await authAxios.get(urls.assets.linkedSubAssetList);
    return data;
  };

  return useQuery("SubAssetLinkedView", getsubAssetLinkedView);
};

//sub asset list by id
export const useEditSubAssetsList = (id: number) => {
  const { authAxios } = useFetchContext();
  const getEditSubAssetList = async (): Promise<any> => {
    const { data } = await authAxios.get(urls.assets.editSubAssetList(id));
    return data;
  };
  return useQuery(["EditSubAsset", id], getEditSubAssetList, {

  });
};

//Edit New Assets
export const linkAssetUpdate = async (params: any): Promise<any> => {
  const { authAxios, payload } = params;
  const { data } = await authAxios.put(urls.assets.linkNewAsset, payload);
  return data;
};

export const useUpdateLinkedAssets = () => {
  return useMutation(linkAssetUpdate);
};

//Remove Linked Asset

export const linkAssetRemove = async (params: any): Promise<any> => {
  const { authAxios, payload } = params;
  const { data } = await authAxios.delete(
    urls.assets.removeLinkAsset(payload.asset_calibration_id)
  );
  return data;
};

export const useRemoveLinkedAssets = () => {
  return useMutation(linkAssetRemove);
};


export const useSubAssetLinkedViewbyID = (id: any) => {
  const { authAxios } = useFetchContext();

  const getsubAssetLinkedView = async (): Promise<any> => {
    const { data } = await authAxios.get(urls.assets.linkedSubAssetListbyID(id));
    return data;
  };

  return useQuery(["SubAssetLinkedViewdataById", id], getsubAssetLinkedView);
};

export const calibrationInfoAdded = async (params: any): Promise<any> => {
  const { authAxios, asset_id, ...postParams } = params;
  const { data } = await authAxios.patch(urls.assets.view_asset(asset_id), postParams);
  return data;
};

export const usecalibrationInfoAdded = () => {
  return useMutation(calibrationInfoAdded);
};


export const useAssetCalibrationHistoryGet = (id: any) => {
  const { authAxios } = useFetchContext();

  const AssetCalibrationHistoryGet = async (): Promise<any> => {
    const { data } = await authAxios.get(urls.assets.AssetCalibrationHistoryGet(id));
    return data;
  };

  return useQuery(["AssetCalibrationHistoryGet", id], AssetCalibrationHistoryGet);
};


export const verifyCalibration = async (params: any): Promise<any> => {
  const { authAxios, ...postParams } = params;
  const { data } = await authAxios.post(urls.assets.VerifyCalibrationDate, postParams);
  return data;
};

export const useVerifyCalibration = () => {
  return useMutation(verifyCalibration);
};

export const useUnitVersion = (procedureResultIds?: number[]) => {
  const { authAxios } = useFetchContext();

  const getUnitVersion = async (): Promise<any> => {
    if (!procedureResultIds || procedureResultIds.length === 0) return null;

    const query = `[${procedureResultIds.join(",")}]`; 

    const { data } = await authAxios.get(urls.units.unitVersion(query)); 

    return data;
  };

  return useQuery(
    ["getUnitVersion", procedureResultIds],
    getUnitVersion,
    {
      enabled: !!procedureResultIds && procedureResultIds.length > 0,
    }
  );
};

export const useHailTestCalculation = (serialnumber: string, enabled: boolean) => {
  const { authAxios } = useFetchContext();

  const getHailTestCalculation = async (): Promise<any> => {
    const { data } = await authAxios.get(`/hailtestcalculation/?serial_number=${serialnumber}`);
    return data;
  };
  return useQuery(["hailTestCalculation", serialnumber], getHailTestCalculation, {
    enabled: enabled && !!serialnumber,
  });
};


export const useStressFileList = (procedureResultIds?: number[]) => {
  const { authAxios } = useFetchContext();

  const getFileList = async (): Promise<any> => {
    if (!procedureResultIds || procedureResultIds.length === 0) return null;

    const query = `${procedureResultIds.join(",")}`;

    const { data } = await authAxios.get(urls.units.stressFileList(query));

    return data;
  };

  return useQuery(["getFileList", procedureResultIds], getFileList, {
    enabled: !!procedureResultIds && procedureResultIds.length > 0,
  });
};

export const stressFileList = async (params: any): Promise<any> => {

  const { authAxios, ...postParams } = params;
  const { data } = await authAxios.post(urls.units.stressRunfile, {
    ...postParams,
  });
  return data;
};

export const useStressrunFileList = () => {
  return useMutation(stressFileList);
};